import type { LineMarketSB, SelectedBetV2 } from '@mwl/core-lib';

/**
 * Ищет в массиве маркетов ауткам с заданным ID.
 *
 * TODO перенести в core-lib
 *
 * @param {Array<LineMarketSB>} markets - Массив маркетов, в котором осуществляется поиск.
 * @param {string} outcomeId - ID ауткама, который необходимо найти.
 *
 * @returns {SelectedBetV2 | null} - Объект с найденным outcomeId и odds, или null, если ауткам не найден.
 */
export function findMarketOutcome(markets: Array<LineMarketSB>, outcomeId: string): SelectedBetV2 | null {
  for (const market of markets) {
    if (market?.outcomes?.length) {
      for (const marketOutcome of market?.outcomes || []) {
        if (marketOutcome.id === outcomeId) {
          return {
            outcomeId: marketOutcome.id,
            odds: marketOutcome.odds,
          };
        }
      }
    }
  }

  return null;
}
